import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReportEntry } from '../../models/report';

@Component({
  selector: 'app-reports-modal',
  templateUrl: './reports-modal.component.html',
  styleUrls: ['./reports-modal.component.scss'],
  standalone: false,
})
export class ReportsModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ReportsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReportEntry,
  ) {}

  get allModesOk(): boolean {
    return this.data.reportAnalyses!.every(ra => ra.status === 'ok');
  }

  close() {
    this.dialogRef.close();
  }
}
